import React from "react";
import "./Testimonials.css";
import CommonHeading from "../../common-component/common-heading/CommonHeading";

const testimonials = [
  {
    name: "Chavi",
    batch: "Batch of 2026 – MBA",
    text:
      "The difference at ATLAS was that learning never stayed inside the classroom. Every project prepared me for my career.",
    image:
      "/assets/images/Testimonial_2_1782990479820_61488eb4963e8218 (2).webp",
  },
  {
    name: "Nishi Sajjanwala",
    batch: "Batch of 2026 – MBA",
    text:
      "Learning from faculty with both academic and industry expertise gave me a fresh perspective on business.",
    image: "/assets/images/image-2_1782727887457_4644bd69827908cf.jpeg",
  },
];

const Testimonials = () => {
  return (
    <section className="testimonial-section">
      <div className="testimonial-container">
        {/* Heading */}
        {/* <div className="testimonial-heading">
          <span>Hear From Those</span>
          <h2>Who’ve Been There</h2>
        </div> */}

        <CommonHeading subTitle="Hear From Those" title="Who’ve Been There " />

        {/* Cards */}
        <div className="testimonial-cards">
          {testimonials.map((item, index) => (
            <div className="testimonial-card" key={index}>
              <div className="testimonial-content">
                <div className="quote-icon">“</div>

                <p className="testimonial-text">{item.text}</p>

                <div className="testimonial-user">
                  <h3>{item.name}</h3>
                  <p>{item.batch}</p>
                </div>
              </div>

              <div className="testimonial-image">
                <img src={item.image} alt={item.name} />
              </div>
            </div>
          ))}
        </div>

        {/* Button */}
        <div className="testimonial-button-wrapper">
          <button className="apply-btn">Apply Now</button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
